import camelcaseKeys from 'camelcase-keys'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { ReservationMethod } from '@/entities/activities/ReservationMethod'

export class Activity {
  constructor (params = {}) {
    const {
      id,
      categoryIds,
      name,
      facilityId,
      reservationMethods,
      ticketTemplateFileId,
      stationId,
      enabledWebappPaymentMethods,
    } = params ? camelcaseKeys(params) : {}
    this.id = id || null
    this.categoryIds = categoryIds || []
    this.name = name ? getTextValue(name) : null
    this.facilityId = facilityId || null
    this.reservationMethods = reservationMethods ? reservationMethods.map((item) => {
      return new ReservationMethod(item)
    }) : []
    this.ticketTemplateFileId = ticketTemplateFileId || null
    this.stationId = stationId
    this.enabledWebappPaymentMethods = camelcaseKeys(enabledWebappPaymentMethods, { deep: true }) || {
      roomCharge: true,
      services: [],
    }
  }
}
